import { Roles } from 'UI/constants/roles';

export const ALL_COMPANY_VISIBILITY_ROLES = [
  Roles.ProductionDirector,
  Roles.Operations,
  Roles.DataCoordinator,
  Roles.Admin,
  Roles.Leadership,
  Roles.Finance
];

export const DOMINATE_TAB_IDS = {
  interviews: 'interviews',
  outstandingBillings: 'outstandingBillings',
  followUpTasks: 'followUpTasks',
  activeInventory: 'hotInventory'
};
